
















import Vue, { VueConstructor } from 'vue';
import { mapState } from 'vuex';
import { Notibar, Appbar, Loading } from '@/components';
import { UserState } from './views/Home/typings';

interface LocalBindings {
	isLoading: boolean;
}

export default (Vue as VueConstructor<Vue & LocalBindings>).extend({
	name: 'App',

	components: {
		Notibar,
		Appbar,
		Loading,
	},

	computed: {
		...mapState('userReducer', {
			isLoading: (state) => (state as UserState).isLoading,
		}),

		isBrowser() {
			return screen.width > 1023;
		},
	},

	created() {
		this.initConsole();
	},

	methods: {
		initConsole(): void {
			const consoleStyle = `
				font-family: -apple-system, sans-serif;
				font-size: 2.5em;
				font-weight: 300;
				border-radius: 5px;
				padding: 15px;
				background: #1D222B;
				color: #fff;
				text-shadow:
						0 0 7px #bc13fe,
						0 0 10px #B4F8C8,
						0 0 21px #A0E7E5
			`;

			console.info('%c  🍩  Github.com/VannsKang  ', consoleStyle);
		},
	},
});
